import { html, mount } from '../core/html.js';
import { get } from '../core/api.js';
import { propertyCard, emptyState } from '../core/ui.js';
import { t } from '../core/i18n.js';

export async function render(main) {
  async function draw() {
    const items = await get('/api/wishlist');
    mount(main, html`<div class="wrap" style="padding-top:20px"><h1>${t('wishlist.title')}</h1>
      ${items.length ? html`<div class="cards four">${items.map((p) => propertyCard(p, { saved: true }))}</div>` : emptyState(t('wishlist.empty_title'), t('wishlist.empty_text'), html`<a class="btn btn-primary" href="#/search">${t('wishlist.explore')}</a>`)}</div>`);
  }
  await draw();
  const onChange = () => draw();
  window.addEventListener('wishlist-changed', onChange);
  return () => window.removeEventListener('wishlist-changed', onChange);
}
